import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { Absences } from '@/schemas/API/GET/employee/absence/response';

export default function useAbsences() {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: absences,
    error,
    mutate,
  } = useSWR<Absences>(
    employeeId ? `/employees/${employeeId}/absences` : null,
    async () =>
      await getFetcher(`/employees/${employeeId}/absences?size=500`)
  );

  return {
    absences,
    error,
    mutate,
  };
}